import src from "IMAGE";
export default { src, width: 1227, height: 581, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAP0lEQVR42oWKMQqAQAwE8/8X2tpZGg/1kkjGYO1xA8PCMrKrsqwbrR2E30T0T7cLK6Wbo6fV+fCHkFmTjJgGL1BifjzrcgAbAAAAAElFTkSuQmCC"};
